import { call, put, takeEvery } from 'redux-saga/effects';
import { AttachmentsTypes } from './actionTypes';
import { getAttachmentsSuccess, getAttachmentsFail, getOneAttachmentSuccess, getOneAttachmentFail } from './actions';

import * as url from '../../helpers/url_helper';

export const fetchAttachments = async (data: any) => {
    const { GUID, type, Number, LayoutType } = data;
    const path = url.API_URL;
    let user;
    const getAuthUser = localStorage.getItem('authUser');
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }
    const query = `query { 
        GetAttachmentNames(Attachment:{
            userId: ${user.id},
            GUID: "${GUID}",
            type: "${type}",
            Number: "${Number}",
            LayoutType: "${LayoutType}",
            }){
            AttachmentsList {
                Identifier
                Name
                Extension
                ShipmentNumber
                ShipmentGUID
                LayoutType
                isValidSize
            }
            }
        }
    `;

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
    }).then((res) => res.json());
    const updatedAttachments = response.data.GetAttachmentNames.AttachmentsList.map((attachment: any) => ({
        ...attachment,
        isSelected: false
    }));

    return updatedAttachments;
};

function* getAttachmentsSaga(data: any) {
    try {
        const response: Promise<any> = yield call(fetchAttachments, data.payload);
        yield put(getAttachmentsSuccess(response));
    } catch (error) {
        yield put(getAttachmentsFail(error));
    }
}


export const fetchOneAttachment = async (data: any) => {
    const { GUID, type, Identifier } = data;
    const path = url.API_URL;
    let user;
    const getAuthUser = localStorage.getItem('authUser');
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }
    const query = `query {
        GetAttachmentData(Attachment:{
            userId: ${user.id},
            GUID: "${GUID}",
            type: "${type}",
            Identifier: ${Identifier}
            }){
            Attachment {
                Identifier      
                Data
            }
            }
    }
    `;
    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
    }).then((res) => res.json());

    return response.data.GetAttachmentData.Attachment;
};

function* getOneAttachmentSaga(data: any) {
    try {
        const response: Promise<any> = yield call(fetchOneAttachment, data.payload);
        yield put(getOneAttachmentSuccess(response));
    } catch (error) {
        yield put(getOneAttachmentFail(error));
    }
}


function* AttachmentsSaga() {
    yield takeEvery(AttachmentsTypes.GET_ATTACHMENTS, getAttachmentsSaga);
    yield takeEvery(AttachmentsTypes.GET_ONE_ATTACHMENT, getOneAttachmentSaga);
}

export default AttachmentsSaga;
